import React, { ChangeEvent } from 'react'
import {
  Box,
  Collapse,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core'
import { useReactiveVar } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { ChevronDown, ChevronUp } from 'react-feather'
import {
  activeVersionVar,
  comparisonVersionVar,
  isComparisonVisibleVar,
  projectVar,
} from '../../apollo/reactive-vars'

export function VersionComparisonSelect(): React.ReactElement {
  const { t } = useTranslation()
  const project = useReactiveVar(projectVar)
  const activeVersion = useReactiveVar(activeVersionVar)
  const comparisonVersion = useReactiveVar(comparisonVersionVar)
  const isComparisonVisible = useReactiveVar(isComparisonVisibleVar)

  if (!project || !activeVersion) {
    return <></>
  }

  const onComparisonVersionChange = (event: ChangeEvent<HTMLInputElement>) => {
    comparisonVersionVar(
      project.versions.find((version) => version.id === event.target.value) ??
        null,
    )
  }

  const comparableVersions =
    project.versions.filter((version) => version.id !== activeVersion.id) ?? []

  if (comparableVersions.length === 0) {
    return <></>
  }

  return (
    <Box mt={1}>
      <Box display="flex" alignItems="center" justifyContent="center">
        <IconButton
          onClick={() => isComparisonVisibleVar(!isComparisonVisible)}
        >
          {!isComparisonVisible ? <ChevronDown /> : <ChevronUp />}
        </IconButton>
      </Box>

      <Collapse in={isComparisonVisible}>
        <Box mt={1}>
          <Box mb={1}>
            <Typography variant="subtitle1">
              {t('sidebar.compareToVersion')}
            </Typography>
          </Box>
          <TextField
            value={comparisonVersion?.id ?? 'none'}
            onChange={onComparisonVersionChange}
            select
          >
            <MenuItem value="none">-</MenuItem>
            {comparableVersions.map((version) => (
              <MenuItem key={version.id} value={version.id}>
                {version.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Collapse>
    </Box>
  )
}
